<template lang="pug">
#fgModal.modal.fade(tabindex='-1' aria-hidden='true')
  .modal-dialog.modal-dialog-centered
    .modal-content
      .position-absolute.close-button.pointer.c-style.mt-2.me-2(@click="$helpers.closeModal('#fgModal')")
        i.fa-solid.fa-x.fa-2x
      .modal-header-cus
        img(src='/new/img/logo.png')
        h2 Forget Password
      form
        .modal-body
          .mb-2
            input.form-control#accountname(type='text' :placeholder="$t('ui.username')" v-model.trim="$v.accountId.$model" @keyup.enter="updatePassword")
          validation(:value="$v.accountId" :name="$t('ui.username')" target="FORGOTPASSWORD")
          .input-group.flex-nowrap
            span.input-group-text.btns.s2#addon-wrapping +63
            input.form-control(type='text' :placeholder="$t('ui.phone_number')" v-model.trim="$v.phoneNumber.$model" @keyup.enter="updatePassword" @keypress="$helpers.onlyNumber" @paste.prevent)
          //- .mb-2.d-flex.justify-content-between
            .btn.btn-warning.ml-2.rounded-0.resend-btn.d-flex.justify-content-center.align-items-center.prefix +63
            input.form-control(type='text' :placeholder="$t('ui.phone_number')" v-model.trim="$v.phoneNumber.$model" @keyup.enter="updatePassword" @keypress="$helpers.onlyNumber" @paste.prevent)
          validation(:value="$v.phoneNumber" :name="$t('ui.phone_number')" target="FORGOTPASSWORD")
        .modal-footer.s2
          .text-center
            button.btn-submit(type='button' @click="updatePassword") {{ $t('ui.send') }}
</template>
<script>
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import validation from "@/library/_validation.vue"
export default {
  components: {
    validation
  },
  data() {
    return {
      accountId: "",
      phoneNumber: "",
      feedback: {
        success: true,
        status: ""
      },
    };
  },
  validations: {
    accountId: {
      required,
    },
    phoneNumber:{
      required
    }
  },
  mounted(){
    var vm = this
    $("#fgModal").on("shown.bs.modal", function() {
      $("#accountname").trigger('focus')
    });

    $("#fgModal").on("hidden.bs.modal", function() {
      vm.reset()
    });
  },
  methods:{
    updatePassword(){
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let account_id = this.accountId
        let contact_phone = this.phoneNumber
        this.loading = true
        this.$store
          .dispatch("user/forgotPassword", { account_id , contact_phone})
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
              this.reset()
              this.$helpers.showDialog(
                this.$t("ui.success"),
                this.$t("message.forgot_password_success"),
                "success",
                this
              );
            } else {
              var vm = this;
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
              }     
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = response.success
            var vm = this;
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          });
      }
    },
    reset(){
      this.accountId = ""
      this.phoneNumber= ""
      this.$v.$reset()
      $("#fgModal").modal("hide");
    }
  }
}
</script>